// extracted by mini-css-extract-plugin
export default {"pet-to-show-container":"pet-selected-to-show_pet-to-show-container__5S4Zd","pet-to-show-footer-container":"pet-selected-to-show_pet-to-show-footer-container__G46Uf"};